<template>
  <main class="safe_phone_pop_wrap">
    <div
      data-v-05ab5af4=""
      class="modal_wrap bottom_modal"
      autoestimation=""
      :class="{ on: isOpen }"
    >
      <div class="modal_inner" @click.self="$emit('close')">
        <div class="modal">
          <div class="safe_phone_pop">
            <div class="ttl_area">
              <h1>채팅방 입장시 안심번호를 공개할까요?</h1>
              <p>
                원활한 상담을 위해 고객님께 안심번호를<br />
                부여하고 매장에 공유합니다.<br />
                (동의하지 않으셔도 채팅방 입장이 가능합니다)
              </p>
            </div>
            <div class="p_sec">
              <dl>
                <dt>나의 안심 전화번호 <span>(24시간 후 소멸)</span></dt>
                <dd class="phone">
                  <p>{{ safeNumber }}</p>
                </dd>
              </dl>
              <dl>
                <dt>연락받을 시간대</dt>
                <dd>
                  <ul class="type_basic">
                    <li>
                      <input
                        type="radio"
                        name="time"
                        id="time_01"
                        checked=""
                        v-model="timeValue"
                        value="모든 시간"
                      />
                      <label for="time_01"><span>모든 시간</span></label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="time"
                        id="time_02"
                        v-model="timeValue"
                        value="오전 시간"
                      />
                      <label for="time_02"><span>오전 시간</span></label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="time"
                        id="time_03"
                        v-model="timeValue"
                        value="오후 시간"
                      />
                      <label for="time_03"><span>오후 시간</span></label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="time"
                        id="time_04"
                        v-model="timeValue"
                        value="저녁 시간"
                      />
                      <label for="time_04"><span>저녁 시간</span></label>
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
            <div class="btm_btn">
              <div class="btn_wrap">
                <button class="btn bo" @click.once="normalChat">
                  아니오
                </button>
                <button class="btn" @click.once="agreeChat">
                  동의합니다
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

// Import Swiper styles
import 'swiper/swiper.scss';

// import Swiper core and required modules

import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import {
  mapActions,
  mapState,
  mapMutations,
  mapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';
import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';
import { authMapGetters, authGetters } from '@common/store/modules';

import KeywordBenefit from '@/common/components/keyword/BenefitMini.vue';
import Reviews from '@/front/customer/views/shops/components/Reviews.vue';

import ImageModal from '@/front/customer/views/shops/modal/ImageModal';
import {
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
} from '@common/lib/common/utils';

import {
  mapActions as reviewMapActions,
  mapGetters as reviewMapGetters,
} from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';
import { sleep, nativeDeviceInfo } from '@common/lib/common/utils';
import Vue from 'vue';
export default {
  name: 'safePhoneModal',
  components: {},
  data() {
    return {
      isOpen: false,
      safeNumber: '',
      timeValue: '모든 시간',
    };
  },
  computed: {},
  methods: {
    normalChat() {
      this.$emit('normalChat');
    },
    agreeChat() {
      this.$emit('agreeChat');
    },
  },
};
</script>
